<section class="c-section--static" *ngIf="!vm.isAuthenticated">
	<div class="c-section__header c-text--center">
		<div class="o-container">
			<div class="o-container">
				<div class="o-grid">
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v">
						<a *ngIf="!vm.isPrevisit" id="headerLogoMinudoc" href="javascript:void(0);" (click)="vm.navigateToRoot($event)" style="z-index: 999; cursor: pointer;" class="c-header__logo c-logo c-logo--en"></a>
						<a *ngIf="vm.isPrevisit" id="headerLogoPrevisit" href="javascript:void(0);" (click)="vm.navigateToRoot($event)" style="z-index: 999; cursor: pointer;" class="c-header__logo c-logo c-logo--previsit c-logo--previsit@up-to-md"></a>
					</div>
				</div>
			</div>
			<!-- Language menu -->
			<nav class="c-nav c-nav--tab-bar" style="z-index: 999; top: 10px; right: 30px;">
				<div class="o-container">
					<div class="c-nav__menu">
						<ul class="c-nav__list">
							<!-- Language menu -->
							<li class="c-nav__item c-nav__dd" [ngClass]="{ 'c-nav__dd--open': vm.isLanguageMenuOpen }">
								<a id="selectedLangMenu" class="c-nav__link c-nav__dd-toggle c-nav__dd-toggle--arrow" (click)="vm.isLanguageMenuOpen = !vm.isLanguageMenuOpen">
									<i class="c-flag c-flag--{{ vm.getLocaleOption(vm.locale).icon }} c-nav__thumb" aria-hidden="true"></i>
									<span id="selectedLangValue" class="c-nav__label c-text c-text--uppercase">{{ vm.getLocaleOption(vm.locale).shortLabel }}</span>
								</a>
								<div class="c-nav__dd-menu">	
									<ul class="c-nav__dd-list">
										<ng-container *ngFor="let language of vm.locales ; let $index=index">
											<li class="c-nav__dd-item" *ngIf="language.locale !== vm.locale" (click)="vm.setLocale(language.locale)">
												<a id="selectLang{{$index}}" href="javascript:void(0)" class="c-nav__dd-link" >
													<i class="c-flag c-flag--{{ language.icon }} c-nav__dd-icon c-nav__thumb" aria-hidden="true"></i>
													<span id="selectLangValue{{$index}}" class="c-text c-text--uppercase">{{ language.shortLabel }}</span>
												</a>
											</li>
										</ng-container>
									</ul>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</nav>
		</div>
	</div>

	<div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--flex o-grid__cell--center@md-and-up u-no-p o-grid__cell--o2@up-to-md">
		<main class="o-container c-container">
			<div class="o-grid o-grid--center-h">
				<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up o-grid__cell--w-40@xl-and-up">
					<div class="c-content">
						<h1 class="c-text--bold c-text--center">{{ "Login.Login_Title" | translateUnauthenticated }}</h1>
						<br><br>
						<div id="skAuthContainer"></div>
						<div id="skAuthScript"></div>
					</div>
				</div>
			</div>
			<loader-overlay *ngIf="vm.loading"></loader-overlay>
		</main>
	</div>
</section>
